<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Clone Job to Dev Sandbox</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-10">
                    <div class="mb-3">
                        <h3 class="form-label">Destination Sandbox</h3>
                        <select class="form-select" v-model="destinationSandbox">
                            <option value="" disabled>Select a dev sandbox</option>
                            <option v-for="sandbox in sandboxOptions" :key="sandbox.value" :value="sandbox.value">
                                {{ sandbox.label }}
                            </option>
                        </select>
                        <div v-if="!sandboxOptions.length" class="form-text text-danger">
                            No dev sandbox supports the "{{ job.kind || 'INTERNAL' }}" job kind.
                        </div>
                    </div>
                    <div class="mb-3">
                        <h3 class="form-label">What would you like to name this job?</h3>
                        <input placeholder="job-name" class="form-control" v-model="jobName">
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-end">
            <button data-bs-dismiss="modal" class="btn btn-secondary" aria-label="Close">
                Close</button>&nbsp;
            <button class="btn btn-primary" :disabled="loading" @click="cloneJob()">
                <div v-if="loading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Clone
                </div>
            </button>&nbsp;
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { isDuplicate } from '../../utils/commonFunction';
export default {
    name: "CloneJobToDevSandbox",
    data() {
        return {
            job: this.modalData,
            destinationSandbox: "",
            jobName: `${this.modalData.name}-`,
            loading: false
        }
    },
    props: {
        modalData: { type: Object },
    },
    computed: {
        ...mapState({
            devSandboxes: state => state.sandbox.devSandboxes,
            sandboxExcludeList: state => state.sandbox.sandboxExcludeList.amdp,
        }),
        sandboxOptions() {
            const jobKind = (this.job.kind || "").toUpperCase();
            return this.devSandboxes ? this.devSandboxes.reduce((list, sandbox) => {
                const kinds = Array.isArray(sandbox.enabled_job_kinds)
                    ? sandbox.enabled_job_kinds.map(kind => kind.toUpperCase())
                    : [];
                if ((kinds.includes(jobKind) || kinds.includes("*")) && !this.sandboxExcludeList.includes(sandbox.name)) {
                    list.push({ label: sandbox.name, value: sandbox.name });
                }
                return list;
            }, []) : [];
        }
    },
    methods: {
        ...mapActions('sandbox', {
            setCurrentSandbox: 'setCurrentSandbox',
            fetchSandboxJobs: 'fetchSandboxJobs',
            createSandboxJob: 'createSandboxJob',
        }),
        async cloneJob() {
            let toastoptions;
            if (!this.destinationSandbox) {
                toastoptions = { message: "Please select a destination sandbox.", type: "error" };
                this.$store.dispatch('addToast', toastoptions);
                return;
            }
            const re = new RegExp("^[a-z0-9-]*$");
            if (!re.test(this.jobName)) {
                toastoptions = { message: "Job name only supports lowercase letters, numbers, and dashes.", type: "error" };
                this.$store.dispatch('addToast', toastoptions);
                return;
            }
            this.loading = true;
            const originalSandbox = this.$store.state.sandbox.currentSandbox;
            let navigatedAway = false;
            this.setCurrentSandbox(this.destinationSandbox);
            try {
                await this.fetchSandboxJobs();
                if (isDuplicate(this.jobName, this.$store.state.sandbox.sandboxJobs, "name", null)) {
                    toastoptions = { message: "Already '" + this.jobName + "' name exists in '" + this.destinationSandbox + "'.", type: "error" };
                } else {
                    const clonedJob = JSON.parse(JSON.stringify(this.job));
                    clonedJob.name = this.jobName;
                    delete clonedJob.updated_at;
                    delete clonedJob.updated_by;
                    delete clonedJob.type;
                    delete clonedJob.created_at;
                    delete clonedJob.created_by;

                    await this.createSandboxJob(clonedJob);
                    this.$store.dispatch('hideModal');
                    await this.$router.push({
                        name: "Sandbox Job Configuration",
                        params: { sandboxId: this.destinationSandbox, jobId: this.jobName },
                    });
                    navigatedAway = true;
                    toastoptions = { message: "Job cloned to '" + this.destinationSandbox + "' successfully.", type: "success" };
                }
            } catch (error) {
                toastoptions = { message: error.response?.data?.error || "Something went wrong when cloning the Job. Please contact support.", type: "error" };
            } finally {
                this.loading = false;
                if (!navigatedAway) {
                    this.setCurrentSandbox(originalSandbox);
                }
                this.$store.dispatch('addToast', toastoptions);
            }
        }
    }
}
</script>

<style></style>
